import React from 'react';
import styles from './index.module.scss';
import { Route } from "react-router-dom";

// componentes
import Consultar from './Consultar';

// escreve o email
export default function Usuarios(){
      
    return <>

        <div className={[styles.divCentro, ''].join(' ')}>
            <Consultar />
        </div>
    </>
}
